module.exports = __webpack_public_path__ + "img/yingxiao_wancheng_icon.4b340b72.png";